/* globals jQuery */


import FreeAssessment from "./modules/FreeAssessment";

if(!document.scrollingElement){
	document.scrollingElement = document.body;
}

// Adds Foreach to NodeLists..
if(typeof NodeList.prototype.forEach !== 'function'){
	NodeList.prototype.forEach = Array.prototype.forEach;
}

import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';
import {Swiper, Navigation, EffectFade, Pagination} from 'swiper/js/swiper.esm.js';
import loadGmaps from 'load-gmaps';
import Choices from 'choices.js';
import Nav from './modules/nav';
import Accordion from './modules/accordion';
import HeaderSlider from './modules/header-slider';
import Charts from './modules/charts';
import Modals from './modules/modals';
import Animations from './modules/animations';
import CustomLightbox from "./modules/CustomLightbox";
import ReadMore from  "./modules/ReadMore";
import webkit_line_clamp from 'webkit-line-clamp';

window.csusa = {
	init: function() {
		Charts.init();
		Modals.init();
		Animations.init();
		this.animatedScroll();
		this.uniLogos();
		this.lightbox.init();
		new FreeAssessment().findAndReplace();

		Swiper.use([Navigation, EffectFade, Pagination]);

		if(typeof NodeList.prototype.forEach !== 'function'){
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		if(document.querySelector('select') !== null){
			document.querySelectorAll('select').forEach(el => {
				el.choices = new Choices(el, {
					searchEnabled: (typeof el.dataset.searchEnabled !== 'undefined'),
					shouldSort : false
				});
			});
		}

		if(document.querySelector('.faqs__dropdown select') !== null){
			const tabs = document.querySelector('.faqs__tabs');
			document.querySelectorAll('.faqs__dropdown select').forEach(el => {
				el.addEventListener('choice', (value) => {
					tabs.querySelectorAll('.tab').forEach(el => {
						el.classList.remove('active');

						if(el.id === 'tab-' + value.detail.choice.value){
							el.classList.add('active');
						}
					});
				});
			});
		}

		if(document.querySelector('.category select') !== null) {
			document.querySelectorAll('.category select').forEach(el => {
				el.addEventListener('choice', (value) => {
					setTimeout(() => {
						if(typeof el.dataset.url !== 'undefined'){
							if(value.target[0].value === ''){
								if(typeof el.dataset.rootUrl !== 'undefined'){
									window.location = window.location.origin + el.dataset.rootUrl;
								} else {
									window.location = window.location.origin + '/events';
								}
							} else {
								window.location = window.location.origin + el.dataset.url + value.target[0].value;
							}
						}
					}, 0);
				});
			});
		}


		if(document.querySelector('.accordion') !== null) {
			document.querySelectorAll('.accordion').forEach(el => {
				el.accordion = new Accordion(el);
			});
		}

		let youtubeEl = document.querySelector('.single-video .youtube-button')
		//if we are on a single video page render the YT button
		if(youtubeEl) {
			if(typeof gapi !== 'undefined' && youtubeEl !== null){
				if(typeof youtubeEl.dataset.channelid !== 'undefined'){
					gapi.ytsubscribe.render(youtubeEl, {
						'channelid': youtubeEl.dataset.channelid,
						'layout': 'default'
					});
				}
			}
		}

		Array.from(document.querySelectorAll('.readmore')).forEach(el => {
			new ReadMore(el)
		})

		if(document.querySelector('[data-customlightbox]') !== null){
			Array.from(document.querySelectorAll('[data-customlightbox]')).forEach(el =>{
				el.lightbox = new CustomLightbox(el);
			});
		}

		// Set Variables for googlemaps loader
		loadGmaps.key = 'AIzaSyDlgI6laHGITyISSRgqLo2R4d1cUfQd98o';
		loadGmaps.version = '3';

		//Add standard class to caldera form validation and fix errorContainer to handle class change
		if(window.Parsley) {
			window.Parsley.on('form:init', form => {
				form.options.errorTemplate = '<span></span>';
				form.options.errorsWrapper = '<span class="form__validation help-block caldera_ajax_error_block"></span>';
				form.options.errorWrapper = '<span></span>';
				form.options.errorsContainer = field => field.$element.closest('.form__group');
			});
		}

		//Allow user to interrupt auto-scrolling
		$(document).bind('scroll mousedown wheel keyup', function(e) {
			if(e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
				$(document.scrollingElement).stop();
			}
		});

		$(document).on('click', '.offices .nav li a, .tabbed-copy .nav li a, .tabbed-icons .nav li a', function(e) {
			e.preventDefault();
			let $parent = $(this).closest('.offices, .tabbed-copy, .tabbed-icons');

			$parent.find('.tab').removeClass('active');
			$(e.currentTarget.hash).addClass('active');

			$parent.find('.nav li a').removeClass('active');
			$(e.currentTarget).addClass('active');

			return false;
		});

		Nav.init();
		this.filter.init();
		// Accordion.init();

		if(window.innerWidth > 575) {
			let max_title_height = 0;

			let post_titles = document.querySelectorAll('.post .post__title')

			/** Calculating the height to set the post titles to. */
			post_titles.forEach(post => {
				// webkit_line_clamp(post, 3);
				let height = post.offsetHeight;
				if(height > max_title_height) {
					max_title_height = height;
				}
			})

			post_titles.forEach(post => {
				post.style.height = max_title_height + "px";
			})
		}

		if(document.querySelector('.map') !== null){
			document.querySelectorAll('.map').forEach(el =>{
				if(typeof el.dataset.lat !== undefined && typeof el.dataset.lng !== undefined){
					loadGmaps().then(function(mapsApi){
						el.map = new mapsApi.Map(el, {
							center: { lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng) },
							zoom: 16,
							disableDefaultUI: true
						});

						el.marker = new mapsApi.Marker({
							position: { lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng) },
							map: el.map
						});
					});
				}
			});
		}
		if(document.querySelector('.sports-slider') !== null){
			document.querySelectorAll('.sports-slider').forEach(el => {
				el.swiper  = new Swiper(el, {
					speed: 400,
					slidesPerView: 4,
					breakpoints: {
						1: {
							slidesPerView: 1,
						},
						700: {
							slidesPerView: 2,
						},
						900: {
							slidesPerView: 3,
						},
						1200: {
							slidesPerView: 4,
						}
					},
					navigation: {
						nextEl: el.querySelector('.swiper-button-next'),
						prevEl: el.querySelector('.swiper-button-prev')
					},
				});
			});
		}

		if(document.querySelectorAll('.event-slider') !== null){
			document.querySelectorAll('.event-slider').forEach(el => {
				el.swiper = new Swiper(el, {
					speed: 400,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					slidesPerView: 1,
					navigation: {
						nextEl: el.querySelector('.swiper-button-next'),
						prevEl: el.querySelector('.swiper-button-prev'),
					},
				});
			});
		}

		if(document.querySelectorAll('.gallery-slider') !== null) {
			document.querySelectorAll('.gallery-slider').forEach(el => {
				el.swiper = new Swiper(el, {
					speed: 400,
					pagination: {
						el: '.pagination',
						type: 'bullets',
						bulletElement: 'li',
						bulletActiveClass: 'active',
						renderBullet: (index, className) => {
							return `<li class="${className}">
								<span>${index + 1}</span>
							</li>`;
						},
						clickable: true,
					},
				});
			});
		}

		document.querySelectorAll('.testimonial-slider').forEach(el => {
			el.swiper = new Swiper(el, {
				slidesPerView: 'auto',
				spaceBetween: 40,
				centeredSlides: true,
				navigation: {
					nextEl: el.querySelector('.swiper-button-next'),
					prevEl: el.querySelector('.swiper-button-prev'),
				}
			});
			el.swiper.slideTo(1);
		});

		document.querySelectorAll('.header--slider').forEach(e => new HeaderSlider(e));
		document.querySelectorAll('.image-text').forEach(el => {
			if(el.querySelector('.btn--read-more') !== null){
				el.querySelector('.btn--read-more').addEventListener('click', ev => {
					ev.preventDefault();

					el.classList.toggle('open');
				});
			}
		});
	},
	filter: {
		timeout: null,
		paged: 2,
		init: function() {
			let filters = document.querySelector('#filters'),
				grid = document.getElementById('athlete-grid'),
				btn = document.getElementById('load-more-athletes');

			if(filters !== null){
				filters.querySelectorAll('.choices select').forEach(el => {
					el.addEventListener('choice', (value, keyCode) => {
						clearTimeout(this.timeout);
						this.timeout = setTimeout(() => {
							let dataString = this.getPathName(filters);
							//console.log( $('#athlete-container').attr('data-url') + dataString);
							window.location = $('#athlete-container').attr('data-url') + dataString;
						}, 500);
					});
				});
			}


			if(btn !== null && grid !== null){
				btn.addEventListener('click', ev => {
					ev.preventDefault();
					let dataString = this.getPathName(filters),
						url = $('#athlete-container').attr('data-url') + dataString + 'page/' + this.paged,
						headers = new Headers({'X-Request-With' : 'xmlhttprequest'});

					btn.disabled = true;

					fetch(url, {
						cache: 'default',
						mode: 'same-origin',
						credentials: 'same-origin',
						headers: new Headers({
							'X-Requested-With': 'XMLHttpRequest',
						})
					})
						.then((res) => {
							return res.text();
						})
						.then(data => {
							grid.insertAdjacentHTML('beforeend', data);
							this.paged++;
							if(parseInt(this.paged) > parseInt(grid.dataset.max)){
								btn.style.display = 'none';
							}
						})
						.catch(er => {
							btn.style.display = 'none';
						})
						.finally(() => {
							btn.disabled = false;
							sr.sync();
						});
				});
			}
		},
		getPathName: function(form){
			let formData = new FormData(form),
				dataString = '';

			for(let pair of formData.entries()) {
				if(pair[1].length){
					dataString += pair[0] + '/' + pair[1] + '/';
				}
			}

			return dataString;
		}
	},
	animatedScroll: function() {
		if(document.querySelector('.animated-link') !== null) {

			document.querySelectorAll('.animated-link').forEach(el => {
				el.addEventListener('click', ev => {
					ev.preventDefault();

					if(document.querySelector(ev.target.hash) !== null){
						let top = $((ev.target.hash)).offset().top - 120;
						$('body, html').animate({ scrollTop: top }, 750);
					}
				});
			});
		}
	},
	uniLogos: function(){
		if(document.querySelector('.animated-logos') !== null){
			document.querySelectorAll('.animated-logos').forEach(el => {
				let images = el.querySelectorAll('img.university__logo');
				el.interval = setInterval(() => {
					let image = images[Math.floor((Math.random() * images.length))];
					image.classList.add('changing');
					image.addEventListener('transitionend', ev => {
						if(!ev.target.classList.contains('changing')){
							return false;
						}

						if(typeof ev.target.dataset.other !== 'undefined'){
							let oldSrc = ev.target.src,
								newSrc = ev.target.dataset.other;

							ev.target.src = newSrc;
							ev.target.dataset.other = oldSrc;
						}

						ev.target.classList.remove('changing');
					})
				}, 1500);
			});
		}
	},
	lightbox: {
		init: function(){
			this.$lightbox = jQuery('[data-remodal-id="lightbox"]').remodal({hashTracking: false});

			if(document.querySelector('.lightbox') !== null){
				document.querySelectorAll('.lightbox').forEach(el => {
					el.addEventListener('click', this.openModal.bind(this));
				});
			}

			$(document).on('opened', '[data-remodal-id="lightbox"]', function () {
				// $(this).css('width', $(this).find('.remodal__content img').outerWidth());
			});

		},
		openModal: function(ev){
			ev.preventDefault();
			this.$lightbox.$modal.css('width', 'auto');

			if(this.$lightbox.$modal[0].querySelector('.remodal__content') !== null){
				let content = this.$lightbox.$modal[0].querySelector('.remodal__content');

				console.log(ev.currentTarget);
				console.log(ev.currentTarget.dataset);
				console.log(ev.currentTarget.dataset.url);

				if(typeof ev.currentTarget.dataset.url === "undefined"){
					return false;
				}

				let image = document.createElement("img");
				image.setAttribute('src', ev.currentTarget.dataset.url);

				content.innerHTML = '';
				content.insertAdjacentElement('afterbegin', image);

				console.log(image);


				this.$lightbox.open();
				// image.closest('.remodal').style.maxWidth = image.offsetWidth + 'px';
			}
			return true;
		}
	}

	//Prefer creating new modules when appropriate, rather than adding functions here
	//If you need something to be globally accessible, you can assign an imported module to this namespace
	//I.e import Contact from './contact';
	//    window.namespace.Contact = Contact;
};

window.csusa.init();

// SVG Sprite Loader
// eslint-disable-next-line no-unused-vars
const __svg__ = {
	path: '../../resources/images/icons/**/*.svg', //Source SVGs path relative to the compiled js (dist/js)
	name: 'images/icons.svg', //Compiled file path relative to dist/
};

svgxhr({
	filename: './wp-content/themes/class/dist/images/icons.svg', //URL to fetch
});
